import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Navber from "./Component/Navbar/Navber";
import BlogDetail from "./Pages/BlogDetail/BlogDetail";
import Blogs from "./Pages/Blogs/Blogs";
import "./style/main.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navber></Navber>
        <Routes>
          <Route path="/" element={<Blogs></Blogs>}></Route>
          <Route
            path="/blogs/:blogId"
            element={<BlogDetail></BlogDetail>}
          ></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
